module.exports = __webpack_public_path__ + "static/img/tese-yga.bafd21b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/tese-yga.png
// module id = 937
// module chunks = 0